interface StarRatingProps {
  /** 0.0〜5.0 のスコア */
  score: number;
  /** 'full' = スコア+星5つ表示, 'compact' = ★スコアのみ */
  variant?: 'full' | 'compact';
}

export function StarRating({ score, variant = 'full' }: StarRatingProps) {
  const displayScore = score.toFixed(1);

  if (variant === 'compact') {
    return <span className="text-amber-500 font-medium">★ {displayScore}</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <span className="font-bold text-xl tabular-nums text-amber-500">{displayScore}</span>
      <div className="relative flex text-2xl leading-none">
        {/* 背景：空星 */}
        <span className="text-gray-200">★★★★★</span>
        {/* 前景：塗り星（幅でクリップ） */}
        <span
          className="absolute inset-0 overflow-hidden text-amber-400 whitespace-nowrap"
          style={{ width: `${(score / 5) * 100}%` }}
        >
          ★★★★★
        </span>
      </div>
    </div>
  );
}
